import { css } from 'lit'

export const cairnMapStyles = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 400px;
    padding: 0;
    margin: 0;
  }

  .map-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    overflow: visible !important;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }

  .map-container {
    flex: 1;
    width: 100%;
    height: 100%;
    position: relative;
    padding: 0;
    margin: 0;
    min-height: 300px;
  }

  .map-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--cairn-text-secondary-color, #64748b);
    font-size: 16px;
    z-index: 1000;
  }

  #mapid {
    width: 100%;
    height: 100%;
  }

  :host([drawing-mode]) #mapid {
    cursor: crosshair !important;
  }

  :host([drawing-mode]) .maplibregl-canvas {
    cursor: crosshair !important;
  }

  :host([extending-mode]) #mapid {
    cursor: crosshair !important;
  }

  :host([extending-mode]) .maplibregl-canvas {
    cursor: crosshair !important;
  }

  :host([measure-mode]:not([measure-shape-selected])) #mapid {
    cursor: crosshair !important;
  }

  :host([measure-mode]:not([measure-shape-selected])) .maplibregl-canvas {
    cursor: crosshair !important;
  }

  :host([select-mode]) #mapid {
    cursor: default !important;
  }

  :host([select-mode]) .maplibregl-canvas {
    cursor: default !important;
  }

  :host([draw-focused]) #mapid {
    cursor: default !important;
  }

  :host([draw-focused]) .maplibregl-canvas {
    cursor: default !important;
  }

  .status-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.4);
    color: white;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
    z-index: 1000;
    height: 60px;
    box-sizing: border-box;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }

  .zoom-controls-group {
    position: absolute;
    bottom: 16px;
    left: 16px;
    display: flex;
    flex-direction: column;
    z-index: 1001;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: var(--cairn-border-radius-lg, 16px);
    overflow: hidden;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  .right-controls-group {
    position: absolute;
    bottom: 16px;
    right: 16px;
    z-index: 1001;
  }

  @media (max-width: 768px) {
    .status-bar {
      bottom: 0;
    }

    .zoom-controls-group .zoom-only {
      display: none;
    }

    .right-controls-group {
      bottom: 16px;
    }

    mode-fab {
    }
  }

  @media (min-width: 769px) {
    .maplibregl-ctrl-zoom {
      display: none !important;
    }

    .zoom-controls-group {
      bottom: 16px;
    }
  }

  .status-metrics {
    display: flex;
    gap: 16px;
    flex: 1;
  }

  .status-metric {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .metric-label {
    font-size: 10px;
    opacity: 0.7;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .metric-value {
    font-size: 16px;
    font-weight: 600;
    margin-top: 2px;
  }

  .record-button {
    background: var(--cairn-error-color, #dc2626);
    border: none;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    color: white;
    font-size: 20px;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .record-button:hover {
    background: var(--cairn-error-color-dark, #b91c1c);
  }

  .record-button.recording {
    background: var(--cairn-error-color-light, #ef4444);
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  .material-icons {
    font-family: 'Material Symbols Outlined';
    font-weight: normal;
    font-style: normal;
    font-size: 24px !important;
    line-height: 1 !important;
    letter-spacing: normal !important;
    text-transform: none !important;
    display: inline-block !important;
    white-space: nowrap !important;
    word-wrap: normal !important;
    direction: ltr !important;
    user-select: none !important;
  }

  .record-button .material-icons {
    font-size: 24px !important;
  }

  .zoom-button {
    background: var(--cairn-surface-color, #ffffff);
    border: none;
    border-radius: 0;
    width: 40px;
    height: 40px;
    color: var(--cairn-text-secondary-color, #64748b);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
    position: relative;
  }

  .zoom-button:first-child {
    border-start-start-radius: var(--cairn-border-radius-lg, 16px);
    border-start-end-radius: var(--cairn-border-radius-lg, 16px);
  }

  .zoom-button:last-child {
    border-end-start-radius: var(--cairn-border-radius-lg, 16px);
    border-end-end-radius: var(--cairn-border-radius-lg, 16px);
  }

  .zoom-button:not(:first-child) {
    border-top: 1px solid var(--cairn-border-color, #e2e8f0);
  }

  .zoom-button:hover {
    background: var(--cairn-surface-hover-color, #f1f5f9);
  }

  .location-zoom-button.active {
    background: var(--cairn-primary-color, #3b82f6);
    color: white;
  }

  .location-zoom-button.active .material-icons {
    color: white;
  }

  .zoom-button .material-icons {
    font-size: 20px !important;
  }

  .feature-point {
    z-index: 1000 !important;
  }

  .feature-point > div {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .feature-label {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    pointer-events: none !important;
  }

  .edit-handle {
    z-index: 2000 !important;
    cursor: grab !important;
  }

  .edit-handle:hover {
    transform: scale(1.2) !important;
  }

  .edit-handle:active,
  .edit-handle.dragging {
    cursor: grabbing !important;
    transform: scale(1.1) !important;
  }

  .first-vertex-handle {
    border: 2px solid #3f5a7a !important;
    background: #3f5a7a !important;
    border-radius: 50% !important;
  }

  .last-vertex-handle {
    border: 2px solid #ef4444 !important;
    background: #ef4444 !important;
    border-radius: 50% !important;
  }

  .vertex-handle {
    background: #ffffff !important;
    border: 1px solid #000000 !important;
    border-radius: 0 !important;
    width: 8px !important;
    height: 8px !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5) !important;
  }

  .midpoint-handle {
    background: #ffffff !important;
    border: 1px solid #000000 !important;
    border-radius: 0 !important;
    width: 6px !important;
    height: 6px !important;
    opacity: 0.8 !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5) !important;
  }

  .radius-handle {
    background: #ffffff !important;
    border: 1px solid #000000 !important;
    border-radius: 0 !important;
    width: 8px !important;
    height: 8px !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5) !important;
  }

  .corner-handle {
    background: #ffffff !important;
    border: 1px solid #000000 !important;
    border-radius: 0 !important;
    width: 8px !important;
    height: 8px !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5) !important;
  }

  .drag-handle {
    background: #ffffff !important;
    border: 1px solid #000000 !important;
    border-radius: 0 !important;
    width: 10px !important;
    height: 10px !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5) !important;
  }

  .trip-map-label {
    max-width: 150px !important;
    width: 150px !important;
  }

  .trip-map-label > div {
    max-width: 150px !important;
    width: 150px !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    line-height: 1.2 !important;
    text-align: center !important;
  }

  .notification {
    position: fixed;
    top: 80px;
    left: 20px;
    right: 20px;
    z-index: 10000;
    padding: 16px 20px;
    border-radius: var(--cairn-border-radius, 8px);
    color: white;
    font-size: 14px;
    line-height: 1.4;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transform: translateY(-100px);
    transition:
      transform 0.3s ease-out,
      opacity 0.3s ease-out;
    opacity: 0;
  }

  .notification.show {
    transform: translateY(0);
    opacity: 1;
  }

  .notification.success {
    background: linear-gradient(135deg, #10b981, #059669);
  }

  .notification.error {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
  }

  .notification .notification-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .notification .notification-text {
    flex: 1;
  }

  .notification .notification-title {
    font-weight: 600;
    margin-bottom: 4px;
  }

  .notification .notification-message {
    font-size: 13px;
    opacity: 0.9;
  }

  .notification .notification-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
  }

  .notification .notification-link {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    color: white;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    text-decoration: none;
    display: inline-block;
    text-align: center;
  }

  .notification .notification-link:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  .notification .notification-close {
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    opacity: 0.7;
    transition: opacity 0.2s;
  }

  .notification .notification-close:hover {
    opacity: 1;
  }

  /* Preview mode: hide all controls, disable interaction */
  :host([preview]) {
    min-height: 0;
    pointer-events: none;
  }

  :host([preview]) .right-controls-group,
  :host([preview]) .zoom-controls-group,
  :host([preview]) cairn-context-bar,
  :host([preview]) layer-switcher,
  :host([preview]) .import-features-btn,
  :host([preview]) plan-feature-import,
  :host([preview]) confirm-dialog,
  :host([preview]) color-picker-dropdown,
  :host([preview]) stroke-style-dropdown,
  :host([preview]) stroke-editor-dropdown,
  :host([preview]) marker-editor-dropdown,
  :host([preview]) label-editor-dropdown,
  :host([preview]) tag-editor-dropdown,
  :host([preview]) layer-picker-dropdown {
    display: none !important;
  }

  /* Popup theming — loaded after maplibre-gl.css so same-specificity wins */
  .maplibregl-popup-content {
    background: var(--cairn-surface-color);
    color: var(--cairn-text-color);
    font-family: var(--cairn-font-family);
    font-size: var(--cairn-text-size-sm);
    border-radius: var(--cairn-border-radius-lg, 12px);
    box-shadow: var(--cairn-shadow-lg);
    padding: var(--cairn-spacing-sm) var(--cairn-spacing-md);
  }

  .maplibregl-popup-content strong {
    color: var(--cairn-text-color);
  }

  .maplibregl-popup-content em {
    color: var(--cairn-text-secondary-color);
  }

  .maplibregl-popup-close-button {
    color: var(--cairn-text-muted-color);
    font-size: 22px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    right: 4px;
    top: 4px;
  }

  .maplibregl-popup-close-button:hover {
    color: var(--cairn-text-color);
    background: var(--cairn-surface-hover-color, rgba(0, 0, 0, 0.05));
  }

  .cairn-context-popup .maplibregl-popup-content {
    padding: var(--cairn-spacing-sm) var(--cairn-spacing-md);
    min-width: 280px;
  }

  .maplibregl-popup-anchor-bottom .maplibregl-popup-tip {
    border-top-color: var(--cairn-surface-color);
  }

  .maplibregl-popup-anchor-top .maplibregl-popup-tip {
    border-bottom-color: var(--cairn-surface-color);
  }

  .maplibregl-popup-anchor-left .maplibregl-popup-tip {
    border-right-color: var(--cairn-surface-color);
  }

  .maplibregl-popup-anchor-right .maplibregl-popup-tip {
    border-left-color: var(--cairn-surface-color);
  }

  /* ─── Route Planning Panel ─────────────────────────────────────────── */

  .route-plan-panel {
    position: absolute;
    top: 16px;
    right: 70px;
    z-index: 1000;
    background: rgba(30, 41, 59, 0.95);
    color: white;
    border-radius: 12px;
    padding: 12px;
    min-width: 240px;
    max-width: 300px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    font-size: 13px;
  }

  .route-plan-header {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .route-plan-spinner {
    font-size: 18px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .route-plan-option {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 8px 10px;
    margin: 4px 0;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    cursor: pointer;
    color: white;
    text-align: left;
    transition:
      background 0.15s,
      border-color 0.15s;
  }

  .route-plan-option:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  .route-plan-option.selected {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }

  .route-plan-swatch {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    flex-shrink: 0;
  }

  .route-plan-option-info {
    flex: 1;
    min-width: 0;
  }

  .route-plan-option-name {
    font-weight: 600;
    font-size: 13px;
  }

  .route-plan-option-stats {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 2px;
  }

  .route-plan-actions {
    display: flex;
    gap: 8px;
    margin-top: 10px;
  }

  .route-plan-save {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px 12px;
    background: #2563eb;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
  }

  .route-plan-save:hover {
    background: #1d4ed8;
  }

  .route-plan-cancel {
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 6px;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.15s;
  }

  .route-plan-cancel:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  /* ── Context detail overlay (mobile full-screen) ── */

  .context-overlay {
    position: absolute;
    inset: 0;
    z-index: 1500;
    background: var(--cairn-surface-color, #ffffff);
    color: var(--cairn-text-color, #1e293b);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .context-overlay-header {
    display: flex;
    align-items: center;
    gap: var(--cairn-spacing-md, 16px);
    padding: var(--cairn-spacing-md, 16px);
    border-bottom: 1px solid var(--cairn-border-color, #e2e8f0);
    background: var(--cairn-surface-color, #ffffff);
    flex-shrink: 0;
  }

  .context-overlay-back {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--cairn-text-color, #1e293b);
  }

  .context-overlay-back .material-icons {
    font-size: 24px;
  }

  .context-overlay-title {
    font-size: var(--cairn-text-size-xl, 24px);
    font-weight: 600;
    color: var(--cairn-text-color, #1e293b);
  }

  .context-overlay-body {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .context-overlay-body map-context-popup {
    min-width: unset !important;
    max-width: unset !important;
    width: 100%;
  }

  .drop-overlay {
    position: absolute;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(15, 23, 42, 0.75);
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s;
  }

  .drop-overlay.visible {
    opacity: 1;
  }

  .drop-overlay-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 32px 48px;
    border: 2px dashed rgba(59, 130, 246, 0.6);
    border-radius: 16px;
    background: rgba(59, 130, 246, 0.08);
  }

  .drop-overlay-inner .material-icons {
    font-size: 48px;
    color: #3b82f6;
  }

  .drop-overlay-inner span:not(.material-icons) {
    font-size: 16px;
    font-weight: 500;
    color: white;
  }
`
